import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";
import Search from "../components/Search";

const AdvancedSearch = () => {
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smoothly scrolling
        });
        
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Busca Avançada</h1>
                <Search isMobile={isMobile} />
            </main>
            <footer>
                <Footer />
                <SiteMap  isMobile={isMobile}/>
            </footer>
        </>
    );
};

export default AdvancedSearch;
